import { combineReducers } from 'redux';

import activeTable from './activeTableReducer';

export default combineReducers({
    activeTable,
});
